






















import { Component, Vue, Prop } from 'vue-property-decorator';
import {validationMixin} from 'vuelidate';
import { numeric, required } from 'vuelidate/lib/validators';
import { ConditionViewModel } from '../models/conditionViewModel';
import { ConditionOperationType } from '../models/conditions';

const greaterThanZero = (value: number) => value > 0;
@Component({
	mixins: [validationMixin],
	validations: {
		liveCondition: {
			value: { required, minValue: greaterThanZero, numeric}
		},
	}
})
export default class DurationCondition extends Vue {
	@Prop() public condition: ConditionViewModel;

	public liveCondition: ConditionViewModel = {
		attribute: '',
		operation: '',
		type: '',
		unit: '',
		value: '',
		result: true
	};

	public mounted() {
		if (this.condition) {
			this.liveCondition = {
				attribute: this.condition.attribute,
				operation: ConditionOperationType.Equals,
				type: this.condition.type,
				value: this.condition.value,
				result: this.condition.result,
				unit: 'seconds',
				invalid: this.condition.invalid
			};

			if (this.liveCondition.invalid) {
				this.$v.$touch();
			}
		}
	}

	public secondsChanged(event: any) {
		this.liveCondition.value = event.target.value;
		this.$v.$touch();
		this.emitConditionChanged();
	}

	private emitConditionChanged() {
		this.liveCondition.invalid = this.$v.$invalid;
		this.$emit('changed', this.liveCondition);
	}

	private complete() {
		this.liveCondition.invalid = this.$v.$invalid;
		this.$emit('completed', this.liveCondition);
	}
}
